import { typedAction } from '@gsc/preact-redux'
import type { RootState } from './store'

export interface TemplateTagsState {
  [key: string]: unknown
}

const initialState: TemplateTagsState = {}

export function setTags(tags: TemplateTagsState) {
  return typedAction('templateTags/SET', tags)
}

type TemplateTagsAction = ReturnType<typeof setTags>

export default function reducer(state = initialState, action: TemplateTagsAction): TemplateTagsState {
  switch (action.type) {
    case 'templateTags/SET':
      return { ...state, ...action.payload }
    default:
      return state
  }
}

// selectors

export function selectTemplateTags(state: RootState): TemplateTagsState {
  return state.templateTags
}

export function selectDeviceType(state: RootState): string | null {
  const value = selectTemplateTags(state)['$deviceType']
  return typeof value === 'string' ? value : null
}
